import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-pc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Navbar = _resolveComponent("Navbar");
  const _component_router_view = _resolveComponent("router-view");
  const _component_PageFooter = _resolveComponent("PageFooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Navbar), _createVNode(_component_router_view), _createVNode(_component_PageFooter)]);
}